import FooterSectionComponent from "./component";
import { StoryObj } from "@storybook/react";

export default {
  component: FooterSectionComponent,
  title: "Layout/Footer Section",
};

export const Default: StoryObj<typeof FooterSectionComponent> = {
  args: {
    internalLinks: [
      {
        title: "VoIP Provider",
        links: [
          {
            name: "Business VoIP  Number",
            title: "Find a VoIP number for your business",
            url: "/phone-number/all-numbers/",
          },
          {
            name: "Transfer number to VoIP",
            title: "Transfer an existing number to our VoIP service",
            url: "/phone-number/keep-my-number/",
          },
          {
            name: "Cloud PBX Phone System",
            title: "Cloud PBX Phone System",
            url: "/business-phone-system/cloud/",
          },
          {
            name: "PAYG VoIP Call Costs",
            title: "Call Costs & Bundles",
            url: "/voice/calls/",
          },
          {
            name: "VoIP Hardware",
            title: "Purchase VoIP Handsets and Headsets",
            url: "/voip-phones/",
            target: "_blank",
          },
          {
            name: "VoIP Phone Numbers",
            title: "VoIP Phone Numbers",
            url: "/phone-number/",
          },
          {
            name: "Virtual Landline",
            title: "Virtual Landline",
            url: "/phone-number/virtual-landline/",
          },
          {
            name: "Business Phone System Features",
            title: "Business Phone System Features",
            url: "/voice/business-phone-system/",
          },
        ],
      },
      {
        title: "Hosted VoIP Plans",
        links: [
          {
            name: "VoIP Plan Pricing",
            title: "View VoIP Plan Pricing",
            url: "/voice/",
          },
          {
            name: "View VoIP Plans",
            title: "View VoIP Plans",
            url: "/plans/",
          },
          {
            name: "Micro-Business Phone System",
            title: "Discover the best VoIP phone system for startups",
            url: "/business-phone-system/startups/",
          },
          {
            name: "Small Business Phone System",
            title: "Discover the best VoIP phone system for small business",
            url: "/business-phone-system/small-business/",
          },
          {
            name: "Enterprise Phone System",
            title: "Discover the best enterprise VoIP phone system",
            url: "/business-phone-system/enterprise/",
          },
          {
            name: "Free VoiP Trial",
            title: "Create your free Yay.com Trial Account",
            url: "/voip/try-free/",
          },
        ],
      },
      {
        title: "Phone Numbers",
        links: [
          {
            name: "SIP Trunks",
            title: "SIP Trunk Call Costs",
            url: "/voice/calls",
          },
          {
            name: "SIP Provider",
            title: "SIP Provider",
            url: "/voip/sip/",
          },
          {
            name: "SIP Trunking",
            title: "SIP Trunking",
            url: "/voip/guide/what-is-sip/",
          },
        ],
      },
      {
        title: "Domains",
        links: [
          {
            name: "Domain Names",
            title: "register Domain Names",
            url: "/domain-names/",
          },
          {
            name: "Domain Name Search",
            title: "Domain Name Search",
            url: "/domain-names/",
          },
          {
            name: "Domain Transfer",
            title: "Domain Transfer",
            url: "/domain-names/transfer-bulk/",
          },
          {
            name: "Backorder Domains",
            title: "Backorder Domains",
            url: "/domain-names/backorder/",
          },
          {
            name: "Domain Name Registration",
            title: "Domain Name Registration",
            url: "/domain-names/pricing/",
          },
          {
            name: "Domain Name Features",
            title: "Domain Name Features",
            url: "/domain-names/registration/",
          },
        ],
      },
      {
        title: "Reseller",
        links: [
          {
            name: "VoIP Reseller",
            title: "VoIP Reseller",
            url: "/reseller/voip/",
          },
          {
            name: "Domain Reseller",
            title: "Domain Reseller",
            url: "/reseller/domains/",
          },
        ],
      },
      {
        title: "Help & Contacts",
        links: [
          {
            name: "Contact Us",
            title: "Have questions? Contact Yay.com",
            url: "/about/contact-us/",
          },
          {
            name: "Frequently Asked Questions",
            title: "FAQ's about VoIP and setup instructions",
            url: "/faq/",
          },
          {
            name: "Download Yay.com Apps",
            title: "Download the Mobile and Desktop VoIP Apps",
            url: "/app/",
          },
          {
            name: "Advantages of VoIP",
            title: "Learn about the advantages of VoIP",
            url: "/voip/",
          },
          {
            name: "What is VoIP?",
            title: "Learn what VoIP is and how it works",
            url: "/voip/guide/what-is/",
          },
          {
            name: "VoIP Beginner's Guide",
            title: "Get started with VoIP",
            url: "/voip/guide/",
          },
          {
            name: "VoIP API Documentation",
            title: "View VoIP API docs",
            url: "/voip/api-docs/",
          },
          {
            name: "Domain API Documentation",
            title: "View Domain store API docs",
            url: "/domain-names/api-docs/",
          },
        ],
      },
      {
        title: "Login / Register",
        links: [
          {
            name: "Login / Register",
            title: "login or register to join Yay.com",
            url: "/register/",
          },
          {
            name: "About Yay",
            title: "Find out more about Yay and our VoIP Services",
            url: "/about/",
          },
          {
            name: "Our News",
            title: "Latest VoIP Telecoms news articles",
            url: "/news/",
          },
          {
            name: "Our Blogs",
            title: "Latest VoIP Cloud and Business phone systems articles",
            url: "/blog/",
          },
          {
            name: "Terms & Conditions",
            title: "Terms & Conditions",
            url: "/about/terms/",
          },
          {
            name: "Privacy Policy",
            title: "Privacy Policy",
            url: "/about/privacy/",
          },
          {
            name: "Cookie Policy",
            title: "Click to view our Cookie Policy",
            url: "/about/cookie-policy/",
          },
          {
            name: "Complaints Policy",
            title: "View our Complaints Policy",
            url: "/about/complaints-policy",
          },
        ],
      },
    ],
    iconGroups: [
      {
        icons: [
          {
            name: "XGrey",
            url: "https://twitter.com/Yay_dot_com",
            width: 24,
            height: 24,
          },
          {
            name: "LinkedinGrey",
            url: "https://www.linkedin.com/company/yayofficial",
            width: 24,
            height: 24,
          },
          {
            name: "FacebookGrey",
            url: "https://www.facebook.com/reliable.business.grade.voip",
            width: 24,
            height: 24,
          },
          {
            name: "InstagramGrey",
            url: "https://www.instagram.com/yay_voip/",
            width: 24,
            height: 24,
          },
          {
            name: "YoutubeGrey",
            url: "https://www.facebook.com/reliable.business.grade.voip",
            width: 24,
            height: 24,
          },
        ],
      },
      {
        label: "Payment Methods",
        icons: [
          {
            name: "VisaBadge",
            width: 34,
            height: 23,
          },
          {
            name: "MasterCardBadge",
            width: 34,
            height: 23,
          },
          {
            name: "AmexBadge",
            width: 34,
            height: 23,
          },
          {
            name: "PaypalBadge",
            width: 34,
            height: 23,
          },
        ],
      },
      {
        label: "Downloads",
        icons: [
          {
            name: "GoogleplayCard",
            url: "https://play.google.com/store/apps/details?id=com.yay.android_app&pli=1",
            color: "black",
            width: 134,
            height: 39,
          },
          {
            name: "AppstoreCard",
            url: "https://apps.apple.com/gb/app/yay-com/id1413192435",
            color: "black",
            width: 119,
            height: 39,
          },
        ],
      },
      {
        label: "Accreditations",
        icons: [
          {
            name: "Iso27001",
            url: "/about/accreditations",
            width: 100,
            height: 40,
          },
          {
            name: "Iso22301",
            url: "/about/accreditations",
            width: 100,
            height: 39,
          },
          {
            name: "CyberEssentials",
            url: "/about/accreditations",
            width: 64,
            height: 51,
          },
          // {
          //   name: "Gov",
          //   url: "/about/accreditations",
          //   width: 50,
          //   height: 51,
          // },
        ],
      },
    ],
    contact: {
      phone_number: "0330 122 6000",
      phone_number_US: "+1 (888) 929 8747",
      email: "help@yay.com",
      name: "©2026 Yay.com",
    },
  },
};
